"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _reactProvider = require("@trycourier/react-provider");

var _reactHooks = require("@trycourier/react-hooks");

var _styled = require("./styled");

var _useHover = _interopRequireDefault(require("../../hooks/use-hover"));

var _markdownToJsx = _interopRequireDefault(require("markdown-to-jsx"));

var _deepExtend = _interopRequireDefault(require("deep-extend"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _tinycolor = _interopRequireDefault(require("tinycolor2"));

var _actions = _interopRequireDefault(require("./actions"));

var _useOnScreen = require("../../hooks/use-on-screen");

var _pins = require("./pins");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var UnreadIndicator = _styledComponents["default"].div.withConfig({
  displayName: "Message__UnreadIndicator",
  componentId: "sc-1wfky41-0"
})(function (_ref) {
  var _theme$brand, _theme$brand$colors, _theme$message;

  var theme = _ref.theme,
      read = _ref.read;
  var primaryColor = (_theme$brand = theme.brand) === null || _theme$brand === void 0 ? void 0 : (_theme$brand$colors = _theme$brand.colors) === null || _theme$brand$colors === void 0 ? void 0 : _theme$brand$colors.primary;
  return (0, _deepExtend["default"])({
    visibility: read ? "hidden" : "visible",
    height: "auto",
    width: 2,
    background: primaryColor,
    position: "absolute",
    left: "1px",
    top: "1px",
    bottom: "1px"
  }, theme === null || theme === void 0 ? void 0 : (_theme$message = theme.message) === null || _theme$message === void 0 ? void 0 : _theme$message.unreadIndicator);
});

var ClickableContainer = _styledComponents["default"].a.withConfig({
  displayName: "Message__ClickableContainer",
  componentId: "sc-1wfky41-1"
})(function (_ref2) {
  var _theme$brand$colors$p, _theme$brand2, _theme$brand2$colors, _theme$message2, _theme$message3;

  var theme = _ref2.theme;
  var primaryColor = (_theme$brand$colors$p = (_theme$brand2 = theme.brand) === null || _theme$brand2 === void 0 ? void 0 : (_theme$brand2$colors = _theme$brand2.colors) === null || _theme$brand2$colors === void 0 ? void 0 : _theme$brand2$colors.primary) !== null && _theme$brand$colors$p !== void 0 ? _theme$brand$colors$p : "#9121c2";
  var tcPrimaryColor = (0, _tinycolor["default"])(primaryColor);
  return (0, _deepExtend["default"])({
    "*, &": {
      "text-decoration": "none"
    },
    cursor: "pointer",
    ".message-container.hover": {
      background: tcPrimaryColor.setAlpha(0.14)
    }
  }, theme === null || theme === void 0 ? void 0 : (_theme$message2 = theme.message) === null || _theme$message2 === void 0 ? void 0 : _theme$message2.container, theme === null || theme === void 0 ? void 0 : (_theme$message3 = theme.message) === null || _theme$message3 === void 0 ? void 0 : _theme$message3.clickableContainer);
});

var MessageContainer = _styledComponents["default"].div.withConfig({
  displayName: "Message__MessageContainer",
  componentId: "sc-1wfky41-2"
})(function (_ref3) {
  var _theme$message4;

  var theme = _ref3.theme;
  return (0, _deepExtend["default"])({
    transition: "background 200ms ease-in-out",
    display: "flex",
    position: "relative",
    padding: "12px",
    minHeight: 60,
    borderBottom: "1px solid",
    borderColor: "var(--ci-structure)",
    "&.read": {
      ".icon": {
        filter: "grayscale(100%)",
        opacity: "0.3"
      }
    },
    "&.archived": {
      filter: "grayscale(100%)"
    }
  }, theme === null || theme === void 0 ? void 0 : (_theme$message4 = theme.message) === null || _theme$message4 === void 0 ? void 0 : _theme$message4.container);
});

var Contents = _styledComponents["default"].div.withConfig({
  displayName: "Message__Contents",
  componentId: "sc-1wfky41-3"
})(function (_ref4) {
  var _theme$message5;

  var theme = _ref4.theme,
      hasIcon = _ref4.hasIcon;
  return _objectSpread({
    marginRight: "auto",
    textAlign: "left",
    marginLeft: hasIcon ? 12 : 0
  }, (_theme$message5 = theme.message) === null || _theme$message5 === void 0 ? void 0 : _theme$message5.contents);
});

var Pinned = _styledComponents["default"].div.withConfig({
  displayName: "Message__Pinned",
  componentId: "sc-1wfky41-4"
})(function (_ref5) {
  var _theme$message6;

  var theme = _ref5.theme,
      color = _ref5.color;
  return (0, _deepExtend["default"])({
    fontSize: "12px",
    fontWeight: 600,
    display: "flex",
    alignItems: "center",
    color: color !== null && color !== void 0 ? color : "rgb(115, 129, 155)",
    svg: {
      paddingRight: "3px"
    },
    img: {
      width: "18px",
      paddingRight: "3px"
    }
  }, theme === null || theme === void 0 ? void 0 : (_theme$message6 = theme.message) === null || _theme$message6 === void 0 ? void 0 : _theme$message6.pinned);
});

var Message = function Message(_ref6) {
  var _actions$length, _brand$inapp$slots$fi, _brand$inapp, _brand$inapp$slots, _brand$inapp2, _brand$inapp2$slots, _pinDetails$label, _pinned$slotId, _pinDetails$icon$valu, _pinDetails$icon, _pinDetails$icon2, _pinDetails$label$val, _pinDetails$label2, _actions$slice;

  var actions = _ref6.actions,
      archived = _ref6.archived,
      areActionsHovered = _ref6.areActionsHovered,
      isMessageActive = _ref6.isMessageActive,
      messageId = _ref6.messageId,
      openLinksInNewTab = _ref6.openLinksInNewTab,
      pinned = _ref6.pinned,
      preview = _ref6.preview,
      read = _ref6.read,
      renderedIcon = _ref6.renderedIcon,
      renderActionsAsButtons = _ref6.renderActionsAsButtons,
      renderPin = _ref6.renderPin,
      title = _ref6.title;
  var courier = (0, _reactProvider.useCourier)();
  var renderActionButtons = renderActionsAsButtons || ((_actions$length = actions === null || actions === void 0 ? void 0 : actions.length) !== null && _actions$length !== void 0 ? _actions$length : 0) > 1;

  var _useInbox = (0, _reactHooks.useInbox)(),
      brand = _useInbox.brand,
      markMessageRead = _useInbox.markMessageRead,
      trackClick = _useInbox.trackClick;

  var pinDetails = pinned !== null && pinned !== void 0 && pinned.slotId ? (_brand$inapp$slots$fi = brand === null || brand === void 0 ? void 0 : (_brand$inapp = brand.inapp) === null || _brand$inapp === void 0 ? void 0 : (_brand$inapp$slots = _brand$inapp.slots) === null || _brand$inapp$slots === void 0 ? void 0 : _brand$inapp$slots.find(function (s) {
    return s.id === (pinned === null || pinned === void 0 ? void 0 : pinned.slotId);
  })) !== null && _brand$inapp$slots$fi !== void 0 ? _brand$inapp$slots$fi : brand === null || brand === void 0 ? void 0 : (_brand$inapp2 = brand.inapp) === null || _brand$inapp2 === void 0 ? void 0 : (_brand$inapp2$slots = _brand$inapp2.slots) === null || _brand$inapp2$slots === void 0 ? void 0 : _brand$inapp2$slots.find(function (s) {
    return s.id === "default";
  }) : undefined;
  var isPinned = Boolean(pinned === null || pinned === void 0 ? void 0 : pinned.slotId);

  var handleActionClick = function handleActionClick(action) {
    return /*#__PURE__*/function () {
      var _ref7 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(event) {
        var _action$data, _action$data2;

        var promises;
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                event.preventDefault();
                promises = [!read && markMessageRead(messageId), (action === null || action === void 0 ? void 0 : (_action$data = action.data) === null || _action$data === void 0 ? void 0 : _action$data.trackingId) && trackClick(messageId, action === null || action === void 0 ? void 0 : (_action$data2 = action.data) === null || _action$data2 === void 0 ? void 0 : _action$data2.trackingId)].filter(Boolean);

                if (!promises.length) {
                  _context.next = 5;
                  break;
                }

                _context.next = 5;
                return Promise.all(promises);

              case 5:
                if (!courier.onRouteChange) {
                  _context.next = 8;
                  break;
                }

                courier.onRouteChange(action === null || action === void 0 ? void 0 : action.href);
                return _context.abrupt("return");

              case 8:
                if (openLinksInNewTab) {
                  window.open(action === null || action === void 0 ? void 0 : action.href, "_blank");
                } else {
                  window.location.href = action === null || action === void 0 ? void 0 : action.href;
                }

              case 9:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function (_x) {
        return _ref7.apply(this, arguments);
      };
    }();
  };

  return /*#__PURE__*/_react["default"].createElement(MessageContainer, {
    className: (0, _classnames["default"])("message-container", {
      hover: isMessageActive && !areActionsHovered,
      pinned: isPinned,
      read: read,
      archived: archived
    })
  }, /*#__PURE__*/_react["default"].createElement(UnreadIndicator, {
    read: read
  }), renderedIcon, /*#__PURE__*/_react["default"].createElement(Contents, {
    hasIcon: Boolean(renderedIcon)
  }, pinDetails && (renderPin ? renderPin(pinDetails) : /*#__PURE__*/_react["default"].createElement(Pinned, {
    color: pinDetails === null || pinDetails === void 0 ? void 0 : (_pinDetails$label = pinDetails.label) === null || _pinDetails$label === void 0 ? void 0 : _pinDetails$label.color,
    className: (_pinned$slotId = pinned === null || pinned === void 0 ? void 0 : pinned.slotId) !== null && _pinned$slotId !== void 0 ? _pinned$slotId : ""
  }, /*#__PURE__*/_react["default"].createElement(_pins.SlotIcon, {
    icon: (_pinDetails$icon$valu = pinDetails === null || pinDetails === void 0 ? void 0 : (_pinDetails$icon = pinDetails.icon) === null || _pinDetails$icon === void 0 ? void 0 : _pinDetails$icon.value) !== null && _pinDetails$icon$valu !== void 0 ? _pinDetails$icon$valu : "default",
    color: pinDetails === null || pinDetails === void 0 ? void 0 : (_pinDetails$icon2 = pinDetails.icon) === null || _pinDetails$icon2 === void 0 ? void 0 : _pinDetails$icon2.color
  }), (_pinDetails$label$val = pinDetails === null || pinDetails === void 0 ? void 0 : (_pinDetails$label2 = pinDetails.label) === null || _pinDetails$label2 === void 0 ? void 0 : _pinDetails$label2.value) !== null && _pinDetails$label$val !== void 0 ? _pinDetails$label$val : "Pinned")), /*#__PURE__*/_react["default"].createElement(_styled.Title, {
    "aria-label": "message title ".concat(title),
    read: read
  }, title), /*#__PURE__*/_react["default"].createElement(_styled.TextElement, {
    "aria-label": "message body ".concat(preview)
  }, preview ? /*#__PURE__*/_react["default"].createElement(_markdownToJsx["default"], null, preview) : null), renderActionButtons ? actions === null || actions === void 0 ? void 0 : (_actions$slice = actions.slice(0, 2)) === null || _actions$slice === void 0 ? void 0 : _actions$slice.map(function (action, index) {
    return /*#__PURE__*/_react["default"].createElement(_styled.ActionElement, {
      primary: index === 0,
      backgroundColor: action.background_color,
      key: "".concat(action.href, "-").concat(index),
      onClick: handleActionClick(action)
    }, action.content);
  }) : undefined));
};

var MessageWrapper = function MessageWrapper(_ref8) {
  var _brand$inapp3, _ref9, _brand$inapp4, _brand$inapp4$icons;

  var actions = _ref8.actions,
      archived = _ref8.archived,
      created = _ref8.created,
      data = _ref8.data,
      defaultIcon = _ref8.defaultIcon,
      formatDate = _ref8.formatDate,
      icon = _ref8.icon,
      isMessageFocused = _ref8.isMessageFocused,
      isMobile = _ref8.isMobile,
      labels = _ref8.labels,
      messageId = _ref8.messageId,
      opened = _ref8.opened,
      openLinksInNewTab = _ref8.openLinksInNewTab,
      pinned = _ref8.pinned,
      preview = _ref8.preview,
      read = _ref8.read,
      renderActionsAsButtons = _ref8.renderActionsAsButtons,
      renderPin = _ref8.renderPin,
      setFocusedMessageId = _ref8.setFocusedMessageId,
      title = _ref8.title,
      trackingIds = _ref8.trackingIds;
  var courier = (0, _reactProvider.useCourier)();

  var _useState = (0, _react.useState)(),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      activeTimeout = _useState2[0],
      setActiveTimeout = _useState2[1];

  var messageRef = (0, _react.useRef)(null);

  var _useState3 = (0, _react.useState)(false),
      _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
      areActionsHovered = _useState4[0],
      setAreActionsHovered = _useState4[1];

  var _useInbox2 = (0, _reactHooks.useInbox)(),
      brand = _useInbox2.brand,
      markMessageOpened = _useInbox2.markMessageOpened,
      markMessageRead = _useInbox2.markMessageRead,
      trackClick = _useInbox2.trackClick;

  var isMessageHovered = (0, _useHover["default"])(messageRef);
  (0, _react.useEffect)(function () {
    var handleFocus = function handleFocus() {
      setFocusedMessageId(messageId);
    };

    var node = messageRef === null || messageRef === void 0 ? void 0 : messageRef.current;

    if (node) {
      node.addEventListener("focusin", handleFocus);
      return function () {
        node.removeEventListener("focusin", handleFocus);
      };
    }
  }, [messageRef === null || messageRef === void 0 ? void 0 : messageRef.current]);
  var isVisible = (0, _useOnScreen.useOnScreen)(messageRef, {
    root: document.querySelector("#inbox-message-list"),
    threshold: 0.6
  });
  (0, _react.useEffect)(function handleMessageVisibility() {
    if (opened || !messageId) {
      return;
    }

    if (activeTimeout) {
      if (isVisible) {
        return;
      }

      clearTimeout(activeTimeout);
      setActiveTimeout(undefined);
      return;
    }

    if (!isVisible) {
      return;
    }

    var THROTTLE_TIMEOUT = 1000;
    var newTimeout = setTimeout(function () {
      markMessageOpened(messageId);
    }, THROTTLE_TIMEOUT);
    setActiveTimeout(newTimeout);
  }, [opened, messageId, isVisible, activeTimeout]);
  (0, _react.useEffect)(function handleMessageUnmount() {
    return function () {
      if (!activeTimeout) {
        return;
      }

      clearTimeout(activeTimeout);
    };
  }, [activeTimeout]);
  var renderedIcon = (0, _styled.getIcon)(
  /* priority:
    1. from message
    2. from props.defaultIcon
    3. from props.brand.inapp.icons.message
    4. from remote brand.inapp.icons.message
  */
  brand !== null && brand !== void 0 && (_brand$inapp3 = brand.inapp) !== null && _brand$inapp3 !== void 0 && _brand$inapp3.disableMessageIcon ? false : (_ref9 = icon || defaultIcon) !== null && _ref9 !== void 0 ? _ref9 : brand === null || brand === void 0 ? void 0 : (_brand$inapp4 = brand.inapp) === null || _brand$inapp4 === void 0 ? void 0 : (_brand$inapp4$icons = _brand$inapp4.icons) === null || _brand$inapp4$icons === void 0 ? void 0 : _brand$inapp4$icons.message, true // 36px icon
  );
  var clickActionDetails = (0, _react.useMemo)(function () {
    var _actions$0$data;

    if (data !== null && data !== void 0 && data.clickAction) {
      return {
        href: data.clickAction
      };
    }

    if (renderActionsAsButtons || !(actions !== null && actions !== void 0 && actions.length) || actions.length > 1) {
      return;
    }

    return {
      trackingId: (_actions$0$data = actions[0].data) === null || _actions$0$data === void 0 ? void 0 : _actions$0$data.trackingId,
      href: actions[0].href
    };
  }, [data === null || data === void 0 ? void 0 : data.clickAction, actions]);
  var containerProps = {
    tabIndex: 0
  };

  if (clickActionDetails !== null && clickActionDetails !== void 0 && clickActionDetails.href) {
    containerProps.href = clickActionDetails === null || clickActionDetails === void 0 ? void 0 : clickActionDetails.href;

    if (openLinksInNewTab) {
      containerProps = _objectSpread(_objectSpread({}, containerProps), {}, {
        target: "_blank",
        rel: "noreferrer"
      });
    }

    containerProps.onClick = /*#__PURE__*/function () {
      var _ref10 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2(event) {
        var promises;
        return _regenerator["default"].wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                event.preventDefault();
                promises = [!read && markMessageRead(messageId), (clickActionDetails === null || clickActionDetails === void 0 ? void 0 : clickActionDetails.trackingId) && trackClick(messageId, clickActionDetails === null || clickActionDetails === void 0 ? void 0 : clickActionDetails.trackingId)].filter(Boolean);

                if (!promises.length) {
                  _context2.next = 5;
                  break;
                }

                _context2.next = 5;
                return Promise.all(promises);

              case 5:
                if (!courier.onRouteChange) {
                  _context2.next = 8;
                  break;
                }

                courier.onRouteChange(clickActionDetails === null || clickActionDetails === void 0 ? void 0 : clickActionDetails.href);
                return _context2.abrupt("return");

              case 8:
                if (openLinksInNewTab) {
                  window.open(clickActionDetails === null || clickActionDetails === void 0 ? void 0 : clickActionDetails.href, "_blank");
                } else {
                  window.location.href = clickActionDetails === null || clickActionDetails === void 0 ? void 0 : clickActionDetails.href;
                }

              case 9:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      return function (_x2) {
        return _ref10.apply(this, arguments);
      };
    }();
  }

  var renderedMessage = (0, _react.useMemo)(function () {
    return /*#__PURE__*/_react["default"].createElement(Message, {
      actions: actions,
      archived: archived,
      areActionsHovered: areActionsHovered,
      isMessageActive: isMessageFocused || isMessageHovered,
      messageId: messageId,
      openLinksInNewTab: openLinksInNewTab,
      pinned: pinned,
      preview: preview,
      read: read,
      renderActionsAsButtons: renderActionsAsButtons,
      renderedIcon: renderedIcon,
      renderPin: renderPin,
      title: title
    });
  }, [actions, archived, areActionsHovered, isMessageFocused, isMessageHovered, messageId, openLinksInNewTab, pinned, preview, read, renderActionsAsButtons, renderedIcon, renderPin, title]);
  return /*#__PURE__*/_react["default"].createElement(_styled.PositionRelative, {
    ref: messageRef,
    "data-testid": "inbox-message",
    className: (0, _classnames["default"])({
      pinned: Boolean(pinned === null || pinned === void 0 ? void 0 : pinned.slotId)
    })
  }, courier.onRouteChange || containerProps.href ? /*#__PURE__*/_react["default"].createElement(ClickableContainer, containerProps, renderedMessage) : /*#__PURE__*/_react["default"].createElement("div", {
    tabIndex: 0
  }, renderedMessage), /*#__PURE__*/_react["default"].createElement(_actions["default"], {
    archived: archived,
    created: created,
    formatDate: formatDate,
    isMessageActive: isMessageFocused || isMessageHovered,
    isMobile: isMobile,
    labels: labels,
    messageId: messageId,
    read: read,
    setAreActionsHovered: setAreActionsHovered,
    trackingIds: trackingIds
  }));
};

var _default = MessageWrapper;
exports["default"] = _default;